import MobileUserProfile from './MobileUserProfile';

export default MobileUserProfile;
